<template>
	<div class="voice-input-page">
		<!-- <div class="bar">
			<span class="name">宠医客</span>
		</div> -->

		<div class="page">
			<div class="webAiVoiceInputheader">
				<span class="title">语音记录问诊对话</span>
				<span class="sub">自动记录文字并生成病历</span>
			</div>

			<div class="input-block">
				<div class="input-label">
					<span class="dot"></span>
					<span class="txt"
						@click="voiceToText('/upload/other/2026-05/m1ZGxLFwNi1779951921041.wav')">请输入病患描述</span>
				</div>
				<div class="input-wrap">
					<textarea id="ta" v-model="toText" placeholder="文字输入收集到的病患信息，或从手机端同步语音转写后的对话文本，将自动生成标准病历"></textarea>
					<div class="char-cnt">
						<span id="cnt">{{ toText.length }}</span> 字
					</div>
				</div>
			</div>

			<div class="hint">
				<span class="txt">确认内容无误后，点击下方按钮生成病历</span>
			</div>

			<div class="btn-wrap">
				<button class="gen-btn microphoneBox" @click="toggleRecording">
					<span class="spin"></span>
					<img class="microphoneImg"
						:src="isRecording ? require('../assets/images/microphone2.png') : require('../assets/images/microphone.png')"
						alt="">
				</button>
			</div>
			<div class="btn-wrap">
				<button class="gen-btn" id="btn" @click="textToDecisionMaing()">
					<span class="spin"></span>
					生成病历
				</button>
			</div>

			<div class="tip">
				<div class="tip-label">提示</div>
				<span class="tip-item">· 语音输入时请靠近麦克风，在安静环境下使用</span>
				<span class="tip-item">· 开始录音前请先获得宠主同意</span>
				<span class="tip-item">· 生成后的病历可在电脑端网页查看，支持分段复制</span>
			</div>

			<div class="foot">内容由AI辅助生成，请结合临床参考。</div>
		</div>
		<div class="toast" id="toast"></div>



		<!-- 侧边栏 -->
		<div class="sidebarBox2">
			<div class="topBox">
				<div class="sidebarTitleBox">
					<div class="sidebarTitle">病历助手</div>
				</div>
                <div class="addBtnBox" @click="createdTextBox()">
                    <img class="addImg" src="../assets/images/webAiIcon5-1.png" alt="">
                    <div class="addTitle">新建对话</div>
                </div>
			</div>
			<div class="historyList">
				<div class="historyListItem" v-for="(item, index) in historyDataList" :key="index"
					@click="jumpwebAiVoiceCase(item)">
					<div :class="index < 3?'historyItem bottom':'historyItem'">
						<div class="text">
							{{ item.case_title }}
						</div>
						<input :ref="'myInput' + index + index" type="text" v-show="item.inpOff" class="editInp"
							v-model="item.case_title" @blur="updateCaseTitle(item)">
						<img class="openBtn" @click.stop="item.editOff = true" src="../assets/images/webAiIcon6.png"
							alt="">
						<div class="bgi" v-show="item.editOff" @click.stop="item.editOff = false"></div>
						<div class="bgi" v-show="item.inpOff" @click.stop="item.inpOff = false"></div>
						<div class="deleteBox" v-show="item.editOff">
							<div class="btnItem" @click.stop="onEdit(item, index + '' + index)">
								<img class="btnIcon" src="../assets/images/editIcon.png" alt="">
								重命名
							</div>
							<div class="btnItem" @click.stop="deleteCase(item)">
								<img class="btnIcon" src="../assets/images/deleteIcon.png" alt="">
								删除
							</div>
						</div>
					</div>
				</div>
				<div class="" v-show="historyDataList.length == 0">
					暂无搜索
				</div>
			</div>
			<div class="btmBox" style="height: 100px;padding-top: 20px;">
				<div class="appBtn" @click="downloadAPP()">
					<img class="logoIcon" src="../assets/images/logoIcon.png" alt="">
					下载宠医客APP
				</div>
			</div>
			<div class="btmBox">
                <img class="userImg"
                    :src="loginInfo.HeadPortrait ? loginInfo.HeadPortrait : require('../assets/images/webAiUserIcon.png')"
                    alt="">
                {{ loginInfo.name }}
            </div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'VoiceInput',
	data() {
		return {
			imgSrc: "https://case.chongyike.com",
			mediaRecorder: null,
			audioChunks: [],
			audioBlob: null,
			audioUrl: null,
			isRecording: false,
			isProcessing: false,
			recordingTime: 0,
			timer: null,
			message: '',
			messageType: '',
			// 语音转的文本
			toText: "",
			// 历史记录
			historyDataList: [],
			// 用户信息
			loginInfo: {}
		};
	},
    created() {
        const that = this
        if (that.Cookies.get("loginInfo")) {
            that.loginInfo = JSON.parse(that.Cookies.get("loginInfo"))
        }
		console.log(that.loginInfo)
		this.getCaseList()
	},

	methods: {
		// 跳转病历详情
		jumpwebAiVoiceCase(item) {
			localStorage.setItem('messageId', item.message_id);
			this.$router.push({
				path: "/webAiVoiceCase",
			})
		},
		/**
		 * 切换录音状态（开始/停止）
		 */
		async toggleRecording() {
			if(this.loginInfo.Statue == 0){
				this.$message({
					showClose: true,
					message: "请先完成认证",
            //     type: "success"
				});
				return false
			}
			if (this.isRecording) {
				await this.stopRecording()
			} else {
				await this.startRecording()
			}
		},

		/**
		 * 开始录音
		 */
		async startRecording() {
			try {
				// 检查浏览器支持
				if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
					this.showMessage('您的浏览器不支持录音功能', 'error')
					return
				}

				// 请求麦克风权限
				const stream = await navigator.mediaDevices.getUserMedia({
					audio: {
						echoCancellation: true,
						noiseSuppression: true,
						sampleRate: 44100
					}
				})

				// 创建 MediaRecorder
				this.mediaRecorder = new MediaRecorder(stream)
				this.audioChunks = []

				// 监听数据可用事件
				this.mediaRecorder.ondataavailable = (event) => {
					if (event.data.size > 0) {
						this.audioChunks.push(event.data)
					}
				}

				// 监听录音停止事件
				this.mediaRecorder.onstop = () => {
					this.createAudioBlob()
					// 停止所有音轨
					stream.getTracks().forEach(track => track.stop())
				}

				// 监听错误事件
				this.mediaRecorder.onerror = (event) => {
					console.error('录音错误:', event.error)
					this.showMessage('录音过程中出现错误', 'error')
					this.resetRecording()
				}

				// 开始录音
				this.mediaRecorder.start(100) // 每100ms收集一次数据

				this.isRecording = true
				this.recordingTime = 0
				this.startTimer()
				this.showMessage('录音中...', 'info')

			} catch (error) {
				console.error('获取麦克风失败:', error)

				if (error.name === 'NotAllowedError') {
					this.showMessage('请允许使用麦克风权限', 'error')
				} else if (error.name === 'NotFoundError') {
					this.showMessage('未检测到麦克风设备', 'error')
				} else {
					this.showMessage('无法启动录音: ' + error.message, 'error')
				}
			}
		},

		/**
		 * 停止录音
		 */
		stopRecording() {
			return new Promise((resolve) => {
				if (this.mediaRecorder && this.isRecording) {
					this.mediaRecorder.stop()
					this.isRecording = false
					this.stopTimer()
					this.isProcessing = true
					// 等待一小段时间确保数据处理完成
					setTimeout(() => {
						this.isProcessing = false
						this.showMessage('录音完成', 'success')
						resolve()
					}, 300)
				} else {
					resolve()
				}
			})
		},

		/**
		 * 创建音频 Blob
		 */
		createAudioBlob() {
			if (this.audioChunks.length === 0) {
				console.warn('没有录制到任何数据')
				return
			}

			this.audioBlob = new Blob(this.audioChunks, { type: 'audio/wav' })
			this.audioUrl = URL.createObjectURL(this.audioBlob)
			this.uploadFile()
			// 触发自定义事件，将音频数据传递给父组件
			// this.$emit('recording-complete', {
			// 	blob: this.audioBlob,
			// 	url: this.audioUrl,
			// 	duration: this.recordingTime
			// })
		},

		/**
		 * 播放录音
		 */
		playRecording() {
			if (this.$refs.audioPlayer) {
				this.$refs.audioPlayer.play()
			}
		},

		/**
		 * 音频播放结束
		 */
		onAudioEnded() {
			// 可以在这里添加播放结束后的逻辑
		},

		/**
		 * 删除录音
		 */
		deleteRecording() {
			try {
				if (this.audioUrl) {
					URL.revokeObjectURL(this.audioUrl)
				}
				this.audioBlob = null
				this.audioUrl = null
				this.audioChunks = []
				this.recordingTime = 0
				this.toText = ""
			} catch (error) {
				console.log(error)
			}
		},

		/**
		 * 开始计时器
		 */
		startTimer() {
			this.timer = setInterval(() => {
				this.recordingTime++

				// 限制最长录音时间（例如5分钟）
				if (this.recordingTime >= 300) {
					this.stopRecording()
					this.showMessage('已达到最长录音时长（5分钟）', 'warning')
				}
			}, 1000)
		},

		/**
		 * 停止计时器
		 */
		stopTimer() {
			if (this.timer) {
				clearInterval(this.timer)
				this.timer = null
			}
		},

		/**
		 * 重置录音状态
		 */
		resetRecording() {
			this.isRecording = false
			this.isProcessing = false
			this.recordingTime = 0
			this.stopTimer()

			if (this.mediaRecorder && this.mediaRecorder.stream) {
				this.mediaRecorder.stream.getTracks().forEach(track => track.stop())
			}
		},

		/**
		 * 清理资源
		 */
		cleanup() {
			this.stopTimer()

			if (this.audioUrl) {
				URL.revokeObjectURL(this.audioUrl)
			}

			if (this.mediaRecorder && this.mediaRecorder.state !== 'inactive') {
				this.mediaRecorder.stop()
			}
		},

		/**
		 * 格式化时长
		 */
		formatDuration(seconds) {
			const mins = Math.floor(seconds / 60)
			const secs = seconds % 60
			return `${String(mins).padStart(2, '0')}:${String(secs).padStart(2, '0')}`
		},

		/**
		 * 显示消息
		 */
		showMessage(text, type = 'info') {
			this.message = text
			this.messageType = type

			// 3秒后自动清除消息
			setTimeout(() => {
				if (this.message === text) {
					this.message = ''
				}
			}, 3000)
		},

		/**
		 * 获取音频文件（供外部调用）
		 */
		getAudioFile() {
			return {
				blob: this.audioBlob,
				url: this.audioUrl,
				duration: this.recordingTime,
				filename: `recording_${new Date().getTime()}.wav`
			}
		},
		
        // 点击重命名
        onEdit(item, index) {
            item.inpOff = true
            item.editOff = false
            var a = 'myInput' + index
            this.$nextTick(() => {
                if (this.$refs[a]) {
                    this.$refs[a][0].focus();
                }
            })
        },
        // 重命名方法
        updateCaseTitle(item) {
            const that = this
            item.inpOff = false
            var data = {
                type: 'updateCaseTitle',
                messageId: item.message_id,
                newName: item.case_title
            }
            this.get("/ai/decisionMaking2", data, 1).then((res) => {
                if (res.data.code == "success") {
				}else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
            })
        },
        // 删除历史记录
        deleteCase(item) {
            const that = this
            item.inpOff = false
            var data = {
                type: 'deleteCase',
                messageId: item.message_id,
            }
            this.get("/ai/decisionMaking2", data, 1).then((res) => {
                if (res.data.code == "success") {
                    var result = res.data.result
                    that.getCaseList()
                    that.$message({
                        showClose: true,
                        message: res.data.message,
                    });
                }
            })
        },
		// uploadFile 上传音频生成病历
		uploadFile() {
			const that = this;
			if (this.audioUrl) {

			} else {
				return false
			}
			// 转文件流数据
			const file = new File([this.audioBlob], 'recording.wav', {
				type: 'audio/wav'
			});
			// 创建FormData并发送
			const formData = new FormData();
			formData.append('file', file);
			var data = {
				type: 'uploadFile',
			}
			this.post("/4/handler", data, formData, 1).then((res) => {
				if (res.data.code == "success") {
					var result = res.data.result
					that.voiceToText(result)
				} else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
			})
		},
		// voiceToText 音频文件地址转换文字
		voiceToText(filePaths) {
			const that = this
			var data = {
				type: 'voiceToText',
				filePaths: filePaths
			}
			this.get("/ai/decisionMaking2", data).then((res) => {
				if (res.data.code == "success") {
					var result = res.data.result
					that.toText = result
					localStorage.setItem('toText', result);
					if (that.jumpwebAiVoiceCase) {
						that.$router.push({
							path: "/webAiVoiceCase",
						})
					}
				} else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
			})
		},
		// 生成病历
		textToDecisionMaing() {
			const that = this
			if(this.loginInfo.Statue == 0){
				this.$message({
					showClose: true,
					message: "请先完成认证",
            //     type: "success"
				});
				return false
			}
			if (this.isRecording) {
				that.jumpwebAiVoiceCase = true
				that.toggleRecording()
			} else if (that.toText) {
				localStorage.setItem('toText', that.toText);
				that.$router.push({
					path: "/webAiVoiceCase",
				})
			} else {
				that.$message({
					showClose: true,
					message: "请输入病患描述",
				});
			}
		},
		// 获取历史记录列表
		getCaseList() {
			const that = this
			var data = {
				type: 'getCaseList',
			}
			this.get("/ai/decisionMaking2", data).then((res) => {
				if (res.data.code == "success") {
					var result = res.data.result
					for (let i = 0; i < result.length; i++) {
						result[i].inpOff = false
						result[i].editOff = false
					}
					that.historyDataList = result
				} else {
					that.$message({
						showClose: true,
						message: res.data.message,
					});
				}
			})
		},
	}
}
</script>

<style scoped lang="scss">
* {
	margin: 0;
	padding: 0;
	box-sizing: border-box;
}

.voice-input-page {
	font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "PingFang SC", "Microsoft YaHei", sans-serif;
	background: #f5f7fa;
	color: #1a1a1a;
	line-height: 1.6;
	min-height: 100vh;
}

.bar {
	background: #fff;
	border-bottom: 1px solid #e5e5e5;
	padding: 12px 24px;
	display: flex;
	align-items: center;
	gap: 10px;
}

.bar .name {
	font-size: 15px;
	font-weight: 600;
	color: #155a8a;
}

.page {
	max-width: 720px;
	margin: 0 auto;
	padding: 40px 24px 60px;
}

/* Header */
.webAiVoiceInputheader {
	text-align: center;
	margin-bottom: 36px;
}

.webAiVoiceInputheader .title {
	font-size: 22px;
	font-weight: 600;
	color: #1a1a1a;
	display: block;
	margin-bottom: 6px;
}

.webAiVoiceInputheader .sub {
	font-size: 14px;
	color: #888;
	display: block;
}

/* Input */
.input-block {
	width: 100%;
	margin-bottom: 36px;
}

.input-label {
	display: flex;
	align-items: center;
	gap: 8px;
	margin-bottom: 12px;
}

.input-label .dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: #0d6fab;
}

.input-label .txt {
	font-size: 15px;
	font-weight: 600;
	color: #0d6fab;
}

.input-wrap {
	border: 1.5px solid #e5e5e5;
	border-radius: 12px;
	padding: 20px 24px;
	background: #fff;
	transition: border-color .2s;
}

.input-wrap:focus-within {
	border-color: #4792ee;
}

.input-wrap textarea {
	width: 100%;
	min-height: 300px;
	border: none;
	outline: none;
	resize: vertical;
	font-size: 15px;
	color: #333;
	line-height: 1.8;
	font-family: inherit;
}

.input-wrap textarea::placeholder {
	color: #bbb;
	font-size: 14px;
}

.char-cnt {
	text-align: right;
	font-size: 12px;
	color: #bbb;
	margin-top: 10px;
}

/* Hint */
.hint {
	text-align: center;
	margin-bottom: 28px;
}

.hint .txt {
	font-size: 14px;
	color: #5d5d5d;
}

/* Button */
.btn-wrap {
	display: flex;
	justify-content: center;
	margin-bottom: 36px;
}

.gen-btn {
	width: 280px;
	height: 48px;
	background: #4792ee;
	border: none;
	border-radius: 24px;
	font-size: 16px;
	font-weight: 600;
	color: #fff;
	cursor: pointer;
	box-shadow: 0 4px 16px rgba(71, 146, 238, .35);
	transition: all .2s;
}

.gen-btn:hover {
	background: #3b7fd8;
	transform: translateY(-1px);
	box-shadow: 0 6px 20px rgba(71, 146, 238, .45);
}

.gen-btn:active {
	transform: scale(.98);
}

.gen-btn:disabled {
	background: #93bff0;
	cursor: not-allowed;
	box-shadow: none;
}

.microphoneBox {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100px;
	height: 100px;
	border-radius: 50%;
	background: #4792ee;
	transition: all .2s;
	cursor: pointer;
	box-shadow: 0 4px 16px rgba(71, 146, 238, .35);

	.microphoneImg {
		width: 30px;
	}
}

/* Tip */
.tip {
	border-left: 4px solid #b4d6ff;
	background: #f0f7ff;
	border-radius: 0 12px 12px 0;
	padding: 16px 20px;
	margin-bottom: auto;
}

.tip .tip-label {
	font-size: 15px;
	font-weight: 600;
	color: #154982;
	margin-bottom: 8px;
}

.tip .tip-item {
	font-size: 13px;
	color: #666;
	line-height: 1.6;
	display: block;
}

/* Footer */
.foot {
	text-align: center;
	margin-top: 40px;
	font-size: 12px;
	color: #ccc;
}

/* Toast */
.toast {
	position: fixed;
	top: 20px;
	left: 50%;
	transform: translateX(-50%) translateY(-100px);
	background: rgba(0, 0, 0, .75);
	color: #fff;
	padding: 12px 24px;
	border-radius: 8px;
	font-size: 14px;
	z-index: 9999;
	opacity: 0;
	transition: all .3s;
	pointer-events: none;
}

.toast.show {
	transform: translateX(-50%) translateY(0);
	opacity: 1;
}

/* Loading spinner */
.spin {
	display: inline-block;
	width: 16px;
	height: 16px;
	border: 2px solid rgba(255, 255, 255, .3);
	border-top-color: #fff;
	border-radius: 50%;
	animation: spin .6s linear infinite;
	margin-right: 8px;
	vertical-align: middle;
}

@keyframes spin {
	to {
		transform: rotate(360deg);
	}
}

.loading .spin {
	display: inline-block;
}

.gen-btn:not(.loading) .spin {
	display: none;
}


.sidebarBox2 {
	position: fixed;
	left: 0;
	top: 0;
	width: 60px;
	height: 100vh;
	user-select: none;
	display: flex;
	flex-direction: column;
	justify-content: space-between;
	background: linear-gradient(#ebf6ff, #f1f9ff, #f9fcff, #fff);
	width: 240px;
	padding: 20px 0;
	box-sizing: border-box;
	background-color: #f2f3ff;

	.topBox {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		align-items: center;

		.sidebarTitleBox {
			display: flex;
			justify-content: space-between;
			align-items: center;
			width: 100%;
			padding: 0 15px;
			box-sizing: border-box;

			.sidebarTitle {
				font-size: 22px;
				// font-weight: 600;
			}

			.offBtn {
				width: 26px;
				cursor: pointer;
			}
		}

		.addBtnBox {
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 10px 20px 10px;
			margin: 20px 0 10px;
			box-sizing: border-box;
			background-color: #fff;
			color: #333;
			border-radius: 5px;
			width: 200px;
			cursor: pointer;

			&:hover {
				box-shadow: 0 0 5px 0px #5ea4f7;
			}
			.addImg {
				width: 21px;
				padding-right: 5px;
			}

			.addTitle {
				font-size: 16px;
			}
		}
	}

	.historyList {
		overflow: auto;
		padding: 0px 10px 20px;
		min-height: 70vh;
		box-sizing: border-box;

		.historyListItem {
			display: flex;
			align-items: center;
			padding: 3px 3px;
			font-size: 14px;
			color: #333;
			cursor: pointer;

			&:hover {
				color: #155a8a;
				border-radius: 5px;
				// border: 1px solid #d5dfff;
				background-color: #eff6ff;
			}

			.historyItem {
				position: relative;
				display: flex;
				align-items: center;
				border-radius: 5px;
				// border: 1px solid #f2f3ff;
				cursor: pointer;

				&:hover {
					border-radius: 5px;
					// border: 1px solid #d5dfff;
					background-color: #eff6ff;

					.openBtn {
						display: block;
					}
				}

				.text {
					width: 192px;
					overflow: hidden;
					text-overflow: ellipsis;
					white-space: nowrap;
					height: 28px;
					line-height: 28px;
					padding: 0 5px;
					padding-right: 30px;
					font-size: 14px;
					box-sizing: border-box;
				}

				.editInp {
					position: absolute;
					top: 0;
					left: 0;
					width: 100%;
					height: 30px;
					padding: 0 5px;
					z-index: 4;
					box-sizing: border-box;
					background-color: #fff;
					border: none;
					user-select: none;
					outline: none;
				}

				.openBtn {
					position: absolute;
					display: none;
					top: 3px;
					right: 10px;
					width: 20px;
				}

				.bgi {
					position: fixed;
					left: 0;
					top: 0;
					width: 100vw;
					height: 100vh;
					z-index: 2;
					background-color: rgba(0, 0, 0, .0);
				}

				.deleteBox {
					position: absolute;
					right: 0;
					bottom: 0;
					padding: 10px;
					transform: translateY(-50%);
					border-radius: 5px;
					box-shadow: 0 0 10px #ccc;
					background-color: #fff;
					z-index: 3;

					.btnItem {
						display: flex;
						align-items: center;
						color: #ff3642;

						&:nth-child(1) {
							color: #636363;
							margin-bottom: 10px;
						}

						.btnIcon {
							width: 20px;
							margin-right: 5px;
						}
					}
				}
			}
			.bottom {
                    .deleteBox {
                        transform: translateY(100%);
                    }
                }

		}
	}

	.btmBox {
		display: flex;
		align-items: center;
		// justify-content: center;
		// width: 300px;
		width: 100%;
		padding: 20px 15px 20px;
		font-size: 18px;
		box-sizing: border-box;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;

		.userImg {
			width: 35px;
			border-radius: 50%;
			margin-right: 5px;
		}

		.appBtn {
			display: flex;
			align-items: center;
			padding: 5px 8px;
			border-radius: 10px;
			font-size: 15px;
			color: #333;
			border: 1px solid #5ea4f7;
			user-select: none;
			cursor: pointer;

			.logoIcon {
				width: 25px;
				padding-right: 10px;
			}
		}
	}
}
</style>